<template>
  <div class="pc_header">
    <div class="pc_header_case">
      <img
        src="../../assets/logo.png"
        alt=""
        class="imgHeader"
        @click="goBack"
      >
      <p class="pc_title">
        <slot />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      console.log('返回')
      location.href = this.pub.config.pcUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.pc_header {
  padding: 10px 0;
  box-shadow: 0px 2px 6px 0px rgba(137, 137, 137, 0.5);
  background: #fff;
  .pc_header_case {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    .imgHeader {
      cursor: pointer;
    }
    .pc_title {
      padding-left: 40px;
      font-size: 24px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
    }
  }
}
</style>
